export const fetchChartData = async (base_url, token, history, setData, setLoading, setError) => {
    try {
        const response = await fetch(`${base_url}/core/analytics/get-analytics/${history}`, {
            method: 'GET',
            headers: { 
                'x-auth-token': token,
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        setData(data);
        setLoading(false)
    } catch (error) {
        console.error('Error fetching chart data:', error);
        setError(error.message);
        setLoading(false);
        throw error;
    }
}